import { array, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = struct({
	name: iotsUtils.NotEmptyString,
	formula: iotsUtils.NotEmptyString,
	additionalParameters: array(string),
});
